import React from "react";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/apps/reducers";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";

import { LocatorSendSingleStore as LocatorSendSingleStoreComponent } from "../components/LocatorSendSingleStore";
import { defaultLocation } from "../defaults";
import { loadStoreByExternalID } from "../thunks";

export const LocatorSendSingleStore = (props: {
    storeID: ISyncStoreID;
}): React.ReactNode => {
    const location = useAppSelector(preferredLocationSelector);
    const dispatch = useAppDispatch();
    const [store, setStore] = React.useState<IRetailStoreWithDistance | null>(
        null,
    );
    const lastStoreIDRef = React.useRef<ISyncStoreID | null>(null);

    React.useEffect(() => {
        if (lastStoreIDRef.current === props.storeID) {
            return;
        }
        lastStoreIDRef.current = props.storeID;
        const effectiveLocation = location || defaultLocation;
        const loadStore = async () => {
            const result = await dispatch(
                loadStoreByExternalID({
                    location: effectiveLocation,
                    storeID: props.storeID,
                }),
            );
            if (result.payload && Array.isArray(result.payload)) {
                setStore(result.payload[0] || null);
            }
        };
        void loadStore();
    }, [location, props.storeID, dispatch]);

    if (!store) {
        return null;
    }
    return <LocatorSendSingleStoreComponent store={store} />;
};
